/**
 * Misc storefront helpers:
 * - Opens chat when the URL contains ?open=chat (Zendesk via openDeskyLiveChat, or Reamaze)
 * - Adds a title to the Shopify theme preview bar iframe
 * - Marks decorative third-party SVG icons as aria-hidden
 */
(function () {
  // Open chat from ?open=chat URL parameter
  function openChatFromUrl() {
    // Read the URL the page was loaded with: VariantSelects.updateURL() runs on load and drops ?open
    var navEntry = window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var urlParams = new URLSearchParams(navEntry ? new URL(navEntry.name).search : window.location.search);
    if (urlParams.get('open') !== 'chat') return;

    var checkChat = setInterval(function () {
      // Wait for zE: before it loads, the custom launcher click is a no-op
      if (typeof window.zE === 'function' && typeof window.openDeskyLiveChat === 'function') {
        clearInterval(checkChat);
        setTimeout(function () {
          window.openDeskyLiveChat();
        }, 500);
        return;
      }

      var chatWidget = document.querySelector('#reamaze-widget');
      if (chatWidget) {
        clearInterval(checkChat);
        setTimeout(function () {
          chatWidget.click();
        }, 500);
      }
    }, 200);
    setTimeout(function () {
      clearInterval(checkChat);
    }, 20000);
  }

  // Give the Shopify preview bar iframe an accessible title
  function setPreviewBarTitle() {
    function apply(frame) {
      if (!frame.title) {
        frame.title = 'Shopify theme preview bar';
      }
    }

    var frame = document.getElementById('PBarNextFrame');
    if (frame) {
      apply(frame);
      return;
    }

    var observer = new MutationObserver(function () {
      var previewFrame = document.getElementById('PBarNextFrame');
      if (previewFrame) {
        apply(previewFrame);
        observer.disconnect();
      }
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // Hide decorative third-party SVG icons from assistive tech
  function fixDecorativeSvgAccessibility(root) {
    var scope = root || document;

    scope
      .querySelectorAll(
        '.gf-refine-toggle-mobile button svg, .gf-refine-toggle-mobile svg, .oke-reviewsSummary-icon > svg'
      )
      .forEach(function (icon) {
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        icon.setAttribute('role', 'presentation');
      });

    scope.querySelectorAll('.oke-reviewsSummary-icon').forEach(function (wrapper) {
      wrapper.setAttribute('aria-hidden', 'true');
    });

    scope
      .querySelectorAll(
        'a.header__heading-link > svg, .side-cart-button svg.icon-cart, svg.arrow-up, .continue-shopping__cart-arrow svg'
      )
      .forEach(function (icon) {
        icon.setAttribute('aria-hidden', 'true');
        icon.setAttribute('focusable', 'false');
        icon.setAttribute('role', 'presentation');
        icon.removeAttribute('alt');
      });
  }

  openChatFromUrl();
  setPreviewBarTitle();
  fixDecorativeSvgAccessibility();

  document.addEventListener('DOMContentLoaded', function () {
    fixDecorativeSvgAccessibility();
  });
  window.addEventListener('load', function () {
    fixDecorativeSvgAccessibility();
  });

  var svgObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        fixDecorativeSvgAccessibility(node);
      });
    });
  });
  svgObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
